<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/u77Vnp/tc-custom/9781418580711.jpg?1708485784626" alt="This image is the cover for the book Finding Purpose Beyond Our Pain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finding Purpose Beyond Our Pain
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A revolutionary approach to dealing with life's challenges that guides readers in how to face them and to recognize them as gifts from God.</b></p><p>At one time or another everyone finds themselves questioning, "Does God still love me? Is there a purpose for all this pain?" Drs. Meier and Henderson teach readers how to face painful struggles head-on in a way that allows them to grow and mature emotionally and spiritually. In this timely book they explore the seven most common life challenges:</p>InjusticeRejectionLonelinessLossDisciplineFailureDeath<p>In addition they offer the three reasons we often miss the gifts these challenges can be. This unique approach to an age-old problem will encourage and challenge readers to grow through their struggles instead of wasting energy trying to avoid them altogether.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul Meier, David L. Henderson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1df4d9f2